import React from 'react'

export default function Game() {
  return (
    <div className="screen-game">
      <h1>Games</h1>
      <div style={{backgroundPosition : 'center', backgroundSize : 'cover'}}>
          <img src="./img/games.jpg" alt="..." />          
      </div>
    </div>
  )
}
